import { ALL_STUDIES_LABEL, TrialCard } from './FilterChips.types';

export const getConditionLabel = (item: TrialCard): string | null => {
  const value =
    item?.fields?.relatedTrial?.fields?.featuredTrialCondition?.fields?.description?.value;
  if (value == null || String(value).trim() === '') {
    return null;
  }
  return String(value).trim();
};

export const buildChipLabels = (items: TrialCard[]): string[] => {
  const uniqueLabels = [
    ...new Set(items.map(getConditionLabel).filter((label): label is string => label !== null)),
  ].sort((a, b) => a.localeCompare(b));

  return [ALL_STUDIES_LABEL, ...uniqueLabels];
};

export const filterItemsByChip = (items: TrialCard[], chip: string): TrialCard[] => {
  if (chip === ALL_STUDIES_LABEL) {
    return items;
  }

  return items.filter((item) => getConditionLabel(item) === chip);
};
